import ArrowRightGreen from "../../assets/images/icons/arrow-right-line-green.svg";
import ArrowRight from "../../assets/images/icons/arrow-right-line.svg";
import { Link } from "react-router-dom";
import { products } from "../../data/products";
import ProductCard from "./Product/ProductCard";

function SectionProducts() {
  const featuredProducts = products.slice(0, 4);

  return (
    <section id="products" className="bg-white">
      <div className="py-12 px-6 md:p-24">
        <div className="mx-auto">
          <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-[38px] md:text-[46px] font-[CormorantGaramond] font-bold text-gray-900">
                Souvenirs for Majlis Doa &amp; Tahlil
              </h2>
              <p className="text-sm md:text-base text-gray-600 mt-2">
                We provide complete services to ensure every farewell is handled with respect and serenity
              </p>
            </div>
            <div className="hidden md:flex justify-end w-full md:w-auto">
              <Link
                to="/products"
                className="group inline-flex items-center gap-2 border border-[#0D7330] font-semibold text-[#0D7330] px-6 py-2 rounded-xl hover:bg-[#0B622A] hover:text-white transition"
              >
                See All
                <span className="relative w-4 h-4">
                  <img
                    src={ArrowRightGreen}
                    alt="arrow"
                    className="absolute inset-0 w-4 h-4 transition-opacity duration-150 opacity-100 group-hover:opacity-0"
                  />
                  <img
                    src={ArrowRight}
                    alt="arrow up right"
                    className="absolute inset-0 w-4 h-4 transition-opacity duration-150 opacity-0 group-hover:opacity-100"
                  />
                </span>
              </Link>
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {featuredProducts.map((product, index) => (
              <ProductCard key={`${product.slug}-${index}`} {...product} />
            ))}
          </div>

          <div className="mt-8 flex justify-center md:hidden">
            <Link
              to="/products"
              className="group inline-flex items-center gap-2 border border-[#0B622A] text-[#0B622A] font-semibold px-6 py-2.5 rounded-xl hover:bg-[#0B622A] hover:text-white transition w-full justify-center"
            >
              See All
              <span className="relative w-4 h-4">
                <img
                  src={ArrowRightGreen}
                  alt="arrow"
                  className="absolute inset-0 w-4 h-4 transition-opacity duration-150 opacity-100 group-hover:opacity-0"
                />
                <img
                  src={ArrowRight}
                  alt="arrow up right"
                  className="absolute inset-0 w-4 h-4 transition-opacity duration-150 opacity-0 group-hover:opacity-100"
                />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionProducts;
